<script setup lang="ts" generic="RadioValue">
import { defineModel } from '#imports'

const modelValue = defineModel<RadioValue>()
</script>

<template>
  <input
    v-model="modelValue"
    type="radio"
    class="checked:ring-radio focus-visible:outline-peacock-300 h-6 w-6 cursor-pointer appearance-none rounded-full border border-gray-300 checked:border-black checked:ring-inset checked:ring-black focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:checked:border-gray-300 disabled:checked:ring-gray-300"
  >
</template>
